import { Stack, Typography } from 'ui';
import { WarningTwoTone } from 'ui/icons';
import { isError } from '../../utils/isError/isError';

export const ErrorDetails = ({ error }: { error: unknown }) => {
  const message = isError(error) ? error.message : 'Something went wrong';

  return (
    <Stack
      component="section"
      sx={{
        alignItems: 'center',
        display: 'flex',
        height: '100%',
        justifyContent: 'center',
      }}
    >
      <WarningTwoTone />
      <Typography align="center">{message}</Typography>
    </Stack>
  );
};
